import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { connect, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { Element } from "react-scroll";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import aboutBg from "../../assets/images/bg/community-about.svg";
import heroBg from "../../assets/images/bg/community1.jpg";
// images
import menuBg from "../../assets/images/bg/menu/account.svg";
import Footer from "../../components/footer";
import FooterBottom from "../../components/footerBottom";
// components
import Header from "../../components/header";
import MainMenu from "../../components/mainMenu";
import SignupModal from "../../components/signupModal";
import { getCommunityDetailsAction } from "../App/actions";
import "./style.scss";
import logo from "../../assets/images/logo.png";
import { Button, Row, Col, Container } from "react-bootstrap";
import CustomButton from "../../components/Buttons/CustomButton";

// removed commented code
// changed map keys
const Community = (props) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [keyword, setKeyword] = useState("");

  const userInfo = useSelector((state) => state?.my_account?.user_info);

  const cookie = new Cookies();

  const isAuth = cookie.get("user_token");

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };

  const handleOpenSignupModal = () => {
    if (cookie.get("user_token")) {
      toast.error("you are already logged in");
    } else {
      setIsModal(true);
    }
  };

  useEffect(() => {
    props.getCommunityDetailsAction();
  }, []);
  const handleClickTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    if (props?.community?.keyword?.length > 0) {
      const data = props?.community?.keyword;
      const pp = data.toString();
      setKeyword(pp);
    }
  }, [props?.community?.keyword]);

  return (
    <>
      <Helmet>
        <title>Join the Clarity Cooperative: A Community for Therapists</title>
        <meta name="title" content={"Join the Clarity Cooperative: A Community for Therapists"} />
        <meta name="description" content={props?.community?.excerpt} />
        <meta name="keywords" content={keyword} />
        <meta property="og:title" content={"Join the Clarity Cooperative: A Community for Therapists"} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={props?.community?.url} />
        <meta property="og:image" content={logo} />
        <meta property="og:site_name" content="clarity cooperative" />
        <meta property="og:description" content={props?.community?.excerpt} />
        <meta name="twitter:card" content={props?.community?.excerpt} />
        <meta property="twitter:domain" content="ccdev.brethren.io" />
        <meta property="twitter:url" content={props?.community?.url} />
        <meta name="twitter:title" content={"Join the Clarity Cooperative: A Community for Therapists"} />
        <meta name="twitter:description" content={props?.community?.excerpt} />
        <meta name="twitter:image" content={logo} />
      </Helmet>
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleBlack" blackLogo />
      <section className="section position-relative commity-hero-section" style={{ backgroundImage: `url(${heroBg})` }}>
        <Container>
          <Row className="align-items-center gy-4">
            <Col lg={6} xs={12} className="pe-xl-5 pe-lg-4 pb-md-0 pb-3">
              <p className="mb-md-4 mb-3 fw-bold">{props.community?.label}</p>
              <h1 className="mb-md-4 mb-3">{props.community?.hero_title}</h1>
              <p className="text-xxl mb-md-4 mb-3">{props.community?.hero_sub_title} </p>
              {!userInfo?.auth_token && (
                <div>
                  <Button onClick={handleOpenSignupModal} variant="primary">
                    {props.community?.hero_button_title}
                  </Button>
                </div>
              )}
            </Col>
            <Col lg={6} xs="auto" className="ps-xl-5 ps-lg-4">
              <ul>
                {props.community?.hero_image?.map((item, i) => (
                  <li key={`${item?.image}`}>
                    <img className="img-fluid" src={item.image} alt={`hero img ${i + 1}`} />
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
      <Element name="commu_supportive">
        <div
          className="section community-supportive"
          style={{
            background: `url(${aboutBg}) no-repeat center center / cover`,
          }}
        >
          <Container>
            <Row className=" align-items-center">
              <Col className="d-lg-block d-none" lg={6} xs={12}>
                <div className="supportive-img" style={{ marginLeft: "-8rem", marginRight: "8rem" }}>
                  <img src={props.community?.supportive_image} alt={props.community?.supportive_title} />
                </div>
              </Col>
              <Col className="text-white" lg={6} xs={12}>
                <h1 className="mb-lg-5 mb-4 pb-xl-3 section-heading text-90 text-uppercase">{props.community?.supportive_title}</h1>
                <h3 className="text-xxl fw-normal mb-4">{props.community?.supportive_sub_title}</h3>

                <p className="mb-4">{props.community?.supportive_paragraph}</p>
                {!isAuth && (
                  <div>
                    <a href={props.community?.supportive_button_link} onClick={handleClickTop}>
                      <CustomButton variant="insurance" type="submit" gradient>
                        {props.community?.supportive_button_title}
                      </CustomButton>
                    </a>
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </div>
      </Element>

      <div className="section community-feature">
        <Container>
          <Row className="flex-lg-wrap flex-wrap-reverse justify-content-between">
            <Col lg={6} xs={12}>
              <ul className="h-100">
                {props.community?.feature_image !== undefined && (
                  <>
                    <img src={props.community?.feature_image[0]?.image} alt="feature" />
                    <img src={props.community?.feature_image[1]?.image} alt="feature" />
                    <img src={props.community?.feature_image[2]?.image} alt="feature" />
                  </>
                )}
              </ul>
            </Col>
            <Col lg={6} xs={12} className="mb-lg-0 mb-3 ps-lg-5">
              <div className="d-flex justify-content-between border-bottom border-dark mb-xl-5 mb-4">
                <h4 className="mb-4">{props.community?.feature_title}</h4>

                {/* <Button variant="primary" type="submit" gradient onClick={handleOpenSignupModal}>
                    {props.community?.feature_button_title}
                  </Button> */}
              </div>
              <Row className="">
                {props.community?.features?.map((item) => (
                  <Col sm={6} key={item?.title} className="mb-3">
                    <h4 className="text-base fw-bold mb-2">{item.title}</h4>
                    <p>{item.paragraph}</p>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
      <FooterBottom />
      <SignupModal show={isModal} onHide={() => setIsModal(false)} />
    </>
  );
};

const mapStateToProps = (state) => ({
  community: state.cms.community_data,
});

export default connect(mapStateToProps, {
  getCommunityDetailsAction,
})(withRouter(Community));
